import { render, staticRenderFns } from "./SubCom2.vue?vue&type=template&id=6f9e5e8a"
import script from "./SubCom2.vue?vue&type=script&lang=js"
export * from "./SubCom2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports